import type { BucketConfigDraft, BucketConfigField } from '@/features/warehouse-sync';
import type { WarehouseDestination } from '@/services/db/warehouse-sync/entity';
import { AzureBlobForm } from './provider-forms/azure-blob-form';
import { GcsForm } from './provider-forms/gcs-form';
import { S3Form } from './provider-forms/s3-form';
import { YandexForm } from './provider-forms/yandex-form';
import { PROVIDER_VALIDATORS } from './provider-forms/validators';
import type { BucketConfigMode, ProviderForm, ProviderFormProps } from './provider-forms/types';

export type { BucketConfigDraft, BucketConfigField, BucketConfigMode, ProviderFormProps };

/**
 * The per-provider credential forms, registered by destination.
 *
 * Both the create wizard and the "Manage configuration" modal render whichever form
 * the destination maps to, so a provider is added in one place rather than in every
 * caller's conditional.
 */
export const PROVIDER_FORMS: Readonly<Record<WarehouseDestination, ProviderForm>> = Object.freeze({
  s3: S3Form,
  gcs: GcsForm,
  yandex: YandexForm,
  azure_blob: AzureBlobForm,
});

/** The empty config a provider's form starts from. */
export const PROVIDER_INITIAL_CONFIG: Readonly<Record<WarehouseDestination, BucketConfigDraft>> = Object.freeze({
  s3: { bucket_name: '', bucket_path: '', access_key: '', secret_key: '', region: '' },
  gcs: { bucket_name: '', bucket_path: '', credentials: '' },
  yandex: { bucket_name: '', bucket_path: '', access_key: '', secret_key: '', region: '' },
  azure_blob: { bucket_path: '', container_sas_url: '' },
});

export function validateBucketConfig(
  destination: WarehouseDestination,
  config: BucketConfigDraft,
  mode: BucketConfigMode,
) {
  return PROVIDER_VALIDATORS[destination](config, mode);
}
